// Filter options configuration
export const FILTER_OPTIONS = {
  price: [
    { label: 'Under £50/hr', value: 'under-50', max: 50 },
    { label: '£50-£100/hr', value: '50-100', min: 50, max: 100 },
    { label: '£100-£150/hr', value: '100-150', min: 100, max: 150 },
    { label: 'Over £150/hr', value: 'over-150', min: 150 }
  ],
  vibe: [
    'cosy', 'relaxed', 'welcoming', 'homey', 'bright', 'versatile', 
    'creative', 'natural light', 'holistic', 'charming', 'professional', 
    'vibrant'
  ],
  eventType: [
    'wellness', 'arts', 'community', 'celebrations'
  ],
  attendees: [
    { label: 'Under 25 people', value: 'under-25', max: 25 },
    { label: '25-50 people', value: '25-50', min: 25, max: 50 },
    { label: '50-100 people', value: '50-100', min: 50, max: 100 },
    { label: 'Over 100 people', value: 'over-100', min: 100 }
  ]
};

export const SORT_OPTIONS = [
  { label: 'Popularity', value: 'popularity' },
  { label: 'Price: Low to High', value: 'price-low' },
  { label: 'Price: High to Low', value: 'price-high' },
  { label: 'Highest Rated', value: 'rating' }
];

export const VENUES_PER_PAGE = 10;
export const MOBILE_BREAKPOINT = 1024;

